import { render, staticRenderFns } from "./listado_puntos.vue?vue&type=template&id=4595661e&scoped=true"
import script from "./listado_puntos.vue?vue&type=script&lang=js"
export * from "./listado_puntos.vue?vue&type=script&lang=js"
import style0 from "./listado_puntos.vue?vue&type=style&index=0&id=4595661e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4595661e",
  null
  
)

export default component.exports